import script from "./LoginHome.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginHome.vue?vue&type=script&setup=true&lang=js"

import "./LoginHome.vue?vue&type=style&index=0&id=e202416a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e202416a"]])

export default __exports__